export const SET_IS_INITIAL_ONBOARDING_OPEN = 'ONBOARDING/SET_IS_INITIAL_ONBOARDING_OPEN';
export const SET_IS_FINAL_ONBOARDING_OPEN = 'ONBOARDING/SET_IS_FINAL_ONBOARDING_OPEN';
export const SET_IS_FROM_REGISTRATION = 'ONBOARDING/SET_IS_FROM_REGISTRATION';